import React from 'react';
import PropTypes from 'prop-types';
import PageHeading from 'components/page-heading';
import PoorText from 'components/poor-text';
import ParallaxHeroBackground from 'components/parallax-hero-background';
import Link from 'components/link';
import LinkButton, {
  sizes as linkButtonSizes,
  arrowDirections as linkButtonArrowDirections,
} from 'components/link-button';

const HowToPageHero = ({ lang, heading, introHtml, allGuidesLink }) => {
  return (
    <div className="how-to-page-hero">
      <ParallaxHeroBackground
        backgroundColor="#FFAE9C"
        className="how-to-page-hero__background"
      />
      <div className="how-to-page-hero__container">
        <div className="how-to-page-hero__content">
          {allGuidesLink && (
            <LinkButton
              className="how-to-page-hero__all-guides-link"
              size={linkButtonSizes.small}
              arrowDirection={linkButtonArrowDirections.left}
              {...allGuidesLink}
            />
          )}
          <strong className="how-to-page-hero__label">{lang.label}</strong>
          {heading && (
            <PageHeading text={heading} className="how-to-page-hero__heading" />
          )}
          {introHtml && (
            <PoorText
              text={introHtml}
              className="poor-text_in_how-to-page-hero"
            />
          )}
        </div>
      </div>
    </div>
  );
};

HowToPageHero.propTypes = {
  lang: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }).isRequired,
  heading: PropTypes.string,
  introHtml: PropTypes.string,
  allGuidesLink: PropTypes.exact(Link.propTypes),
};

export default HowToPageHero;
